import type {ModelFilterTechnicalDataGroup} from '@volkswagen-onehub/car-technical-details-bff';
import type {TranslateFunction} from './translate';

export function resolveDataGroupName(
  group: ModelFilterTechnicalDataGroup,
  translate: TranslateFunction,
) {
  return group.i18nKey ? translate(group.i18nKey) : group.name || '';
}
